// Canonical status labels used by UI badges and form selectors.
export const TOUR_STATUS_CATALOG = {
  1: 'draft',
  2: 'in_review',
  3: 'published',
  4: 'archived',
  5: 'cooming_soon'
};

export const TOUR_STATUS_OPTIONS = [
  { value: 1, label: 'draft' },
  { value: 2, label: 'in_review' },
  { value: 3, label: 'published' },
  { value: 4, label: 'archived' },
  { value: 5, label: 'cooming soon' }
];

// Resolves unknown/invalid numeric status values to a safe label.
export function getTourStatusLabel(status) {
  const value = Number(status);
  return TOUR_STATUS_CATALOG[value] || 'unknown';
}
